import { render, staticRenderFns } from "./DocumentContractProfileTab.vue?vue&type=template&id=5becc106&scoped=true&"
import script from "./DocumentContractProfileTab.vue?vue&type=script&lang=ts&"
export * from "./DocumentContractProfileTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5becc106",
  null
  
)

export default component.exports